import { Button, ModalOverlay, Text } from "@components/atoms";
import { AlertCircle } from "lucide-react";

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  buttonText?: string;
}

/**
 * Error / timeout modal molecule.
 * Similar layout to SuccessModal but with a red alert icon.
 */
export function ErrorModal({
  isOpen,
  onClose,
  title,
  message,
  buttonText = "Aceptar",
}: ErrorModalProps) {
  return (
    <ModalOverlay isOpen={isOpen} onClose={onClose}>
      <div
        className="flex flex-col items-center justify-center gap-4 rounded-2xl bg-white p-6 sm:p-8 w-full max-w-[550px]"
        style={{ minHeight: 320 }}
      >
        <Text
          variant="h2"
          as="h2"
          className="font-semibold text-black text-center"
        >
          {title}
        </Text>
        <AlertCircle size={100} className="text-red-500" />
        <Text variant="body" as="p" className="text-black text-center">
          {message}
        </Text>
        <Button
          className="w-full max-w-[340px] h-[50px] border border-primary-110 bg-secondary-120 hover:opacity-90"
          onClick={onClose}
        >
          {buttonText}
        </Button>
      </div>
    </ModalOverlay>
  );
}
